import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Paper,
  Typography,
} from '@gogame/components';

import Status from 'scenes/PlayersActivities/components/Status';

export default ({ data }) => {
  return {
    color: 'secondary',
    date: data?.requestTime,
    title: <Typography>Referral request</Typography>,
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem label={'Inviter UID'} field={'inviterUid'} />
          <DescriptionItem label={'Invited UID'} field={'invitedUid'} />
          <DescriptionItem label={'Advertising Id'} field={'advertisingId'} />
          <DescriptionItem
            label={'Status'}
            field={'status'}
            type={'status'}
            valueParser={(value) => ({ id: value })}
            statusFactory={Status}
          />
          <DescriptionItem
            label={'Sync Time'}
            field={'syncTime'}
            type={'date'}
            timeZone={'utc'}
          />
        </DescriptionList>
      </Paper>
    ),
  };
};
